export enum METHOD {
    GET = 'GET',
    POST = 'POST',
    PUT = 'PUT',
    PATCH = 'PATCH',
    DELETE = 'DELETE',
}

export interface RequestParams {
    urlPart: string;
    body?: unknown;
    initialHeaders?: Record<string, string | number | undefined>;
}

export interface GetShippingMethodsQueryParams {
    state?: string;
    zipCode?: string;
    city?: string;
    address?: string;
}

export interface GetBasketTaxResponse {
    basketCost: number;
    basketTax: number;
    basketTotal: number;
}

export interface GetBraintreeResponse {
    clientToken: string;
}

export interface UpdateShippingMethodBody {
    shipmentId: number;
    shippingMethodId: number;
}

export interface GetBasketTaxQueryParams {
    state?: string;
    postalCode?: string;
    city?: string;
}

export interface ApiRequestParams extends RequestParams {
    method: METHOD;
}

export interface ApiResponse<T> {
    success: boolean;
    data: T;
}

export enum OrderType {
    Unknown = -1,
    Buying = 0,
    Rental = 1,
    RentalKeep = 2,
    RentalUpgrade = 3,
    Selling = 4,
    Combined = 5,
}

export enum ReferenceType {
    Unknown = 0,
    Order = 1,
    Product = 2,
    LineItem = 3,
    Asset = 4,
}

export enum ReferenceValueType {
    Unknown = 0,
    MasterId = 1,
    Id = 100,
    Token = 200,
    ExternalRef = 300,
}

export interface OrderReference {
    orderType: OrderType;
    referenceType: ReferenceType;
    source?: string;
    value?: string;
    valueType: ReferenceValueType;
}

export interface User {
    id: number;
    email: string;
}

export interface Experiment {
  variant: string;
};

export type ExperimentsResponse = Record<string, Experiment>;
